import React from 'react';
import { lazyComponent } from '@unisporkal/react-lazy-component';
import { ErrorBoundary } from '@unisporkal/react-instrumentation';
import { useSite } from '@unisporkal/sites';
import { GalleryOverlay, GallerySetup } from 'app/components/shared';
import { DownloadSelectionAdapter } from 'app/adapters/shared/DownloadSelectionAdapter';
import { useAgreements } from 'src/react/shared/api';

const Gallery = lazyComponent((props) =>
  import(`app/components/${props.siteName}/Gallery/Gallery`)
);

const Search = () => {
  const { nickname: siteName } = useSite();
  // Primes the agreements cache once, here, so the fetch suspends at the page
  // root rather than inside whichever consumer renders first. Return value
  // deliberately unused — consumers read the same query.
  useAgreements();

  return (
    <ErrorBoundary
      appName="uni-search"
      component="Search"
    >
      <DownloadSelectionAdapter>
        <Gallery siteName={siteName} />
      </DownloadSelectionAdapter>
      <GalleryOverlay />
      <GallerySetup />
    </ErrorBoundary>
  );
};

export default Search;
